import React, { useEffect } from "react";
import "./index.css"; // Custom CSS file
import HeroSectionCarousel from "../carousel";
import {
  ContactLocations,
  data1,
  // StockMarketWidget,
  TradingTools,
} from "../home";
// import InquiryForm from "../../components/Inquiry-form";
// import { TrickerWidget } from "../../pages/horizantalWidget";
// import  StockTicker  from "../../components/Ticker";
import PSXTicker from "../../components/PSXTicker";

// C:\Users\amjad\Documents\GitHub\orbit_web\src\pages\horizantalWidget.js
export default function NewHome() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
   
   <div className="new-home-container">
      <HeroSectionCarousel />
      {/* little gap */}

      <div className="trading-tools-container">
        
        <section className="">
          <h2 className="trading-tools-heading">Why Choose Us?</h2>
          <p className="trading-tools-description">
            Get instantttt access to the best tools and advice to maximize your
            investments. We ensure the ultimate safety of client funds while
            enhancing profitability.
          </p>
          <div className="grid-hero-sec">
            <div className="trading-grid">
              {data1.map((v, i) => (
                <div className="trading-card">
                  {v.logo}
                  <h3 className="trading-title">{v.heading}</h3>
                  <p className="trading-text">{v.para}</p>
                </div>
              ))}
            </div>
            {/* <InquiryForm /> */}
          </div>
        </section>
      </div>
     

      {/* <TrickerWidget /> */}
 

      {/* <StockMarketWidget /> */}
      <TradingTools />
      <ContactLocations />
    </div>
  );
}
